
export class Note {
  track: string;
  text: string;
  noteId: string;
  celldir: CellDirection[] = [] as CellDirection[];

  public constructor(track: string = "", text: string = "", noteId:string | undefined = undefined,) {
    this.track = track;
    this.text = text;
    this.noteId = noteId || Date.now().toString();
  }

}

export class CellDirection {
  number: number;
  direction: string;

  public constructor(number: number, direction: string) {
    this.number = number;
    this.direction = direction;
  }


}